import { Suspense, useContext, useEffect, useState } from "react";
import React from "react";
import Loader from "../Loader";
import AttendanceModal from "../../Utils/Modals/AttendanceModal";
import { urlLinks } from "../../UrlLinks";
import axios from "axios";
import SingleDropdown from "../../Utils/Dropdown/SingleDropdown";
import { MyContext } from "../../context/Context";

export default function MarkAttendance() {
  const { setIsNavbarVisible, setMarkAttendanceVisible } =
    useContext(MyContext);
  const [projectList, setProjectList] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    projectId: -1,
    projectName: "",
  });
  const [userId, setUserId] = useState("");
  const [accessErr, setAccessErr] = useState("");

  useEffect(() => {
    const currentPath = window.location.pathname.replace(/\/$/, "");
    if (currentPath === "/mark-attendance") {
      setIsNavbarVisible(true);
    }
  }, [window.location.pathname]);

  useEffect(() => {
    setMarkAttendanceVisible(true);
    const fetchProjectListDeatails = async (userId) => {
      let projectArray = [];
      try {
        const response = await axios.get(
          `${urlLinks.baseUrl}/${urlLinks.taskModal}/${urlLinks.getProjects}?userId=${userId}`
        );

        const attendanceProjects = response.data.response.filter(
          (i) => i.attendance === 1
        );

        attendanceProjects.map((i) =>
          projectArray.push({
            projectId: i.projects_id,
            projectName: i.project_name,
            selfieRequired: i.selfie === 1 ? true : false,
            startTime: i.shiftStartTime,
            endTime: i.shift_end_time,
            attendancePageVisible: i.tcs_attendance_allotment === 1 ? true : false,
            geo_fencing: i.geo_fencing === 1 ? true : false,
            radius: i.radius || 500,
          })
        );
        setProjectList(projectArray);
      } catch (error) {
        console.log(error)
      }
    };
    const userId = localStorage.getItem("userId");
    fetchProjectListDeatails(userId);
    setUserId(userId);
  }, []);

  useEffect(() => {
    if (selectedOption.projectId === -1 && projectList.length !== 0) {
      setSelectedOption((prev) => ({ ...prev, ...projectList[0] }));
    }
  }, [projectList]);
  

  return (
    <section className="w-full flex flex-col justify-center p-4 bg-gradient-to-b from-[#F1F9FF] via-[#F6F6F6] to-white">
      <Suspense fallback={<Loader />}>
        <section className="flex flex-col gap-5 w-full">
          <SingleDropdown
            projectList={projectList}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            setAccessErr={setAccessErr}
          />
          <AttendanceModal
            isSelfieRequired={selectedOption.selfieRequired}
            shiftStartTime={selectedOption.startTime}
            shiftEndTime={selectedOption.endTime}
            projectId={selectedOption.projectId}
            attendancePageVisible={selectedOption.attendancePageVisible}
            userId={userId}
            geo_fencing={selectedOption.geo_fencing}
            radius={selectedOption.radius}
            accessErr={accessErr}
            setAccessErr={setAccessErr}
          /> 
        </section>
      </Suspense>
    </section>
  );
}
